module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_kimono@3x-7afe0566b7568a17ac31892cfbc24019.webp";